import { useCookie, useRuntimeConfig } from '#app'

import type { Locale } from '@backmarket/http-api'

import { COOKIE_LANGUAGE } from '../constants'

/**
 * @private Not to be used outside this module.
 * @returns The locale stored in the cookie if this is allowed by module config.
 *
 * @example
 * const locale = useI18nLocaleFromCookies() // `fr-fr`
 */
export default function useI18nLocaleFromCookies(): Locale | null {
  const config = useRuntimeConfig()

  if (!config.public.i18n.shouldLookForLocaleInCookie) {
    return null
  }

  return useCookie(COOKIE_LANGUAGE).value as Locale
}
